import {
  getContactMethods,
  getDefaultContactMethods,
  postContactMethod,
  contactExists,
  generateContactPayload
} from './util';

export const SELECT_CONTACT_METHOD = 'SELECT_CONTACT_METHOD';

export const FETCH_CONTACT_METHODS_REQUEST = 'FETCH_CONTACT_METHODS_REQUEST';
export const FETCH_CONTACT_METHODS_SUCCESS = 'FETCH_CONTACT_METHODS_SUCCESS';
export const FETCH_CONTACT_METHODS_ERROR = 'FETCH_CONTACT_METHODS_ERROR';

export const POST_CONTACT_METHOD_REQUEST = 'POST_CONTACT_METHOD_REQUEST';
export const POST_CONTACT_METHOD_SUCCESS = 'POST_CONTACT_METHOD_SUCCESS';
export const POST_CONTACT_METHOD_ERROR = 'POST_CONTACT_METHOD_ERROR';

const saveSelectedContactMethod = payload => ({ type: SELECT_CONTACT_METHOD, payload });

const fetchContactMethodsRequest = () => ({ type: FETCH_CONTACT_METHODS_REQUEST });
const fetchContactMethodsSuccess = payload => ({ type: FETCH_CONTACT_METHODS_SUCCESS, payload });
const fetchContactMethodsError = payload => ({ type: FETCH_CONTACT_METHODS_ERROR, payload });

const postContactMethodRequest = () => ({ type: POST_CONTACT_METHOD_REQUEST });
const postContactMethodSuccess = payload => ({ type: POST_CONTACT_METHOD_SUCCESS, payload });
const postContactMethodError = payload => ({ type: POST_CONTACT_METHOD_ERROR, payload });

export function fetchContactMethods(user) {
  return async (dispatch) => {
    dispatch(fetchContactMethodsRequest());
    try {
      const response = await getContactMethods(user);
      if (response.status === 200) {
        const allContactMethods = response.data.contact_methods;
        const defaultContactMethods = getDefaultContactMethods(allContactMethods);
        defaultContactMethods.forEach((contactMethod) => {
          dispatch(saveSelectedContactMethod(contactMethod));
        });
        dispatch(fetchContactMethodsSuccess(allContactMethods));
      }
    } catch {
      dispatch(fetchContactMethodsError(['Encountered an error when retrieving contact methods']));
    }
  };
}

export function updateContactIfNeeded(user, contactType, contactData) {
  return async (dispatch, getState) => {
    try {
      const existingContactMethods = getState().contactMethods.all;
      if (!contactExists(existingContactMethods, contactType, contactData)) {
        const contactPayload = generateContactPayload(contactData, contactType);
        dispatch(postContactMethodRequest());
        const { status, data } = await postContactMethod(user, contactPayload);
        if (status === 201) {
          const contactMethod = data.contact_method;
          dispatch(saveSelectedContactMethod({ type: contactType, method: contactMethod }));
          dispatch(postContactMethodSuccess(contactMethod));
        }
      }
      return true;
    } catch (error) {
      if (error.request) {
        const { errors } = JSON.parse(error.request.response).error;
        dispatch(postContactMethodError(errors));
      } else {
        const formatContactType = {
          phone: 'phone number',
          sms: 'SMS number',
          email: 'email address',
        };
        const defaultError = [`Your ${formatContactType[contactType]} was not updated.`];
        dispatch(postContactMethodError(defaultError));
      }
      return false;
    }
  };
}

export function clearContactMethodsError() {
  return async (dispatch) => {
    dispatch(postContactMethodError([]));
  };
}
